import axios from 'axios';
import router from '@/router';
import envs from '@/envs';
import AlarmMsg from '@/utils/alarmMsg';
import store from '@/store';
import { applyAuthTokenInterceptor } from '@/utils/TokenManager';
import tokenStore from '@/utils/TokenManager/tokenStore';

const baseUrl = process.env.NODE_ENV === 'development' ? envs.devUrl : envs.buildUrl;

/** 로딩 화면을 사용하지 않을 API endpoint 목록 */
const excludeLoadingAPIs = ['/user/getMailVerificationConfirm', '/ggoods/cartItemList'];

/** 한번에 request 발생 시 동일한 오류 알림 노출하지 않도록 하기 위해 카운트 */
let errorCount = 0;

const service = axios.create({
  baseURL: baseUrl,
  timeout: 1000 * 10,
});

applyAuthTokenInterceptor(service);

/** Request interceptor */
service.interceptors.request.use(
  (config) => {
    if (!excludeLoadingAPIs.includes(config.url)) {
      store.dispatch('loadingStart');
    }

    const accessToken = tokenStore.get().accessToken;
    if (accessToken) {
      config.headers['Authorization'] = accessToken;
      config.data['userNo'] = store.getters.userNo;
    }

    return config;
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  },
);

/** Response interceptor */
service.interceptors.response.use(
  (response) => {
    const isLoginAPI = response.config.url.indexOf('/login') > -1;

    store.dispatch('updateLastRequestTime');
    if (!excludeLoadingAPIs.map((url) => `${response.config.baseURL}${url}`.replace(/\/\//g, '/')).includes(response.config.url)) {
      store.dispatch('loadingComplete');
    }

    const res = response.data;

    // 알수없는 서버오류 처리
    if (res.code === 'ERR0000') {
      //AlarmMsg.getMsg(res)
      //console.error('[Error]', response)
      return res;
    }

    // 비즈머니 서버 오류
    if (res.code === 'ERR0800') {
      //AlarmMsg.showMsg('[ERR0800]비즈머니 서버 오류입니다.')
      console.log('[ERR0800]비즈머니 서버 오류입니다.');
      return res;
    }

    // 회원 잠금
    if (res.code === 'ERR0112') {
      if (!isLoginAPI && !errorCount) {
        errorCount += 1;
        tokenStore.clear();
        AlarmMsg.showMsg('회원님의 계정이 잠금 처리되어 서비스 이용이 불가합니다.').then(() => {
          store.dispatch('Logout');
        });
      }
      return res;
    }

    // 이용중지
    if (res.code === 'ERR0124') {
      if (!isLoginAPI && !errorCount) {
        errorCount += 1;
        tokenStore.clear();
        AlarmMsg.showMsg('회원님의 계정을 이용중지 처리하여 서비스 이용이 불가합니다.').then(() => {
          store.dispatch('Logout');
        });
      }
      return res;
    }

    // 마스터회원이 서브회원 탈퇴시킨 경우
    if (res.code === 'ERR0122') {
      if (!isLoginAPI && !errorCount) {
        errorCount += 1;
        tokenStore.clear();
        AlarmMsg.showMsg('회원님의 계정을 탈퇴처리하여 서비스 이용이 불가합니다.').then(() => {
          store.dispatch('Logout');
        });
      }
      return res;
    }

    if (res.code === 'ERR0125') {
      tokenStore.clear();
      AlarmMsg.showMsg('오랜시간 접속하여 로그인을 다시 진행하세요.').then(() => {
        store.dispatch('Logout');
      });
      return res;
    }

    return res;
  },
  (error) => {
    store.dispatch('loadingComplete');

    if (error.code === 'ECONNABORTED') {
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      AlarmMsg.showMsg('세션이 만료되었거나, 로그인이 실패되었습니다.').then(() => {
        router.push('/login');
      });
    }

    console.error('[Request Error]', error);
    return Promise.reject(error);
  },
);

export default service;
